module.exports = __webpack_public_path__ + "img/ic_video_stop_land.f426a9bb.png";